<template>
  <div>
    <div class="min-vh-100">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col xl="4" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">MESSAGE LOG DETAIL</h1>
        </b-col>
      </CRow>
      <div class="mt-3 bg-white-border p-3">
        <b-row class="no-gutters my-3">
          <b-col>
            <div class="font-weight-bold">Time</div>
            <div>
              {{ new Date(messageDetail.createTime) | moment($formatDateTime) }}
            </div>
          </b-col>
          <b-col>
            <div class="font-weight-bold">Status Code</div>
            <div>{{ messageDetail.statusCodeName }}</div>
          </b-col>
        </b-row>
        <b-row class="no-gutters my-3">
          <b-col>
            <div class="font-weight-bold">From</div>
            <div>{{ messageDetail.channelSender }}</div>
          </b-col>
          <b-col>
            <div class="font-weight-bold">To</div>
            <div>{{ messageDetail.channelReceiver }}</div>
          </b-col>
        </b-row>
        <b-row class="no-gutters my-3">
          <b-col>
            <div class="font-weight-bold">Response Time</div>
            <div>
              {{ new Date(messageDetail.createTime) | moment($formatDateTime) }}
            </div>
          </b-col>
        </b-row>
        <b-row class="no-gutters my-3">
          <b-col>
            <div class="font-weight-bold">Message</div>
            <div>{{ messageDetail.message }}</div>
          </b-col>
        </b-row>
        <b-row class="no-gutters my-3">
          <b-col>
            <div class="font-weight-bold mb-2">Row Request</div>
            <vue-json-pretty
              v-if="messageDetail.body"
              :data="messageDetail.body"
              :deep="4"
              :path="'res'"
              :deepCollapseChildren="true"
              :show-double-quotes="false"
              :show-length="false"
              :show-line="false"
              :collapsed-on-click-brackets="true"
            >
            </vue-json-pretty>
            <div v-else>-</div>
          </b-col>
          <b-col>
            <div class="font-weight-bold mb-2">Row Response</div>
            <vue-json-pretty
              v-if="messageDetail.responseMessage"
              :data="messageDetail.responseMessage"
              :deep="4"
              :path="'res'"
              :deepCollapseChildren="true"
              :show-double-quotes="false"
              :show-length="false"
              :show-line="false"
              :collapsed-on-click-brackets="true"
            >
            </vue-json-pretty>
            <div v-else>-</div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col class="d-flex justify-content-end">
            <b-button class="btn-details-set btn-cancel" @click="$router.go(-1)"
              >CANCEL</b-button
            >
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
export default {
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      messageDetail: {
        body: '{"events":[{"type":"message","replyToken":"","source":{"type":"bot","ddotsGUID":"8d492a19-0510-4d63-be4f-e86ef81d72cc","displayName":"สโรชา","userId":"8d492a19-0510-4d63-be4f-e86ef81d72cc","channelType":"WEB","channelId":"WEB_KERRY","accountSFId":null},"message":{"type":"text","id":"220210907111757378846731","text":"😅 ขอโทษค่ะ \\nพูดอีกครั้งได้ไหมคะ หรือดูรายละเอียดตามนี้ได้เลยค่ะ\\n -บริการ","typeFile":null,"surveyScore":null},"timestamp":1630988277397,"mode":"active","prechatDetails":null}]}',
        channelReceiver: "SALESFORCE",
        channelSender: "INTEGRATION",
        createTime: "2021-09-07T11:17:58",
        endPoint: null,
        id: 84921,
        intentTypeId: 0,
        isDeleted: 0,
        languageId: 1,
        message:
          "😅 ขอโทษค่ะ \nพูดอีกครั้งได้ไหมคะ หรือดูรายละเอียดตามนี้ได้เลยค่ะ\n -บริการ",
        messageChannelTypeId: 11,
        messageId: "220210907111757378846731",
        messageLogTypeId: 1,
        messageType: 1,
        platformConfigId: 2,
        receiver: "",
        referenceId: 0,
        responseMessage:
          '{"message":"Insert failed. First exception on row 0; first error: CANNOT_INSERT_UPDATE_ACTIVATE_ENTITY, LiveChatTranscriptTrigger: execution of BeforeInsert\\n\\ncaused by: System.StringException: Invalid id: 8d492a19-0510-4d63-be4f-e86ef81d72cc\\n\\nExternal entry point\\nClass.LiveChatTranscripts.onBeforeInsert: line 35, column 1\\nClass.fflib_SObjectDomain.handleBeforeInsert: line 203, column 1\\nClass.fflib_SObjectDomain.triggerHandler: line 434, column 1\\nClass.fflib_SObjectDomain.triggerHandler: line 387, column 1\\nTrigger.LiveChatTranscriptTrigger: line 8, column 1: []"}',
        sendTime: "2021-09-07T11:17:57",
        sender: "8d492a19-0510-4d63-be4f-e86ef81d72cc",
        statusCode: 500,
      },
    };
  },
  filters: {
    pretty: function (value) {
      return JSON.stringify(JSON.parse(value), null, 2);
    },
  },
  created: async function () {
    await this.getMessageDetailById();
  },
  methods: {
    getMessageDetailById: async function () {
      let body = {
        id: this.$route.params.id,
        collection: this.$route.params.collection,
      };
      await this.axios
        .post(`${this.$baseUrl}/MessageLog/GetMessageLogDetail`, body)
        .then((data) => {
          if (data.result === 1) {
            this.messageDetail = data.detail;
            if (this.messageDetail.body) {
              this.messageDetail.body = JSON.parse(this.messageDetail.body);
            }
            if (this.messageDetail.responseMessage) {
              this.messageDetail.responseMessage = JSON.parse(
                this.messageDetail.responseMessage
              );
            }
          }
        });
    },
  },
};
</script>

<style lang="sass" scoped>
</style>